import { useMemo } from "react"
import PropTypes from "prop-types"
import ListItemDropDown from "components/list-item-dropdown"
import { METRIC_OPTIONS } from "helpers/metrics/definitions"
import { useAnalytics } from "connected-components/analytics"
import { useAssetViewHeaderHandlers } from "connected-components/asset-view/hooks/use-asset-view-header-handlers"
import { useSourceTemplateMetricIds } from "connected-components/asset-view/hooks/use-source-displayed-metrics"
import { COMPOSITION_VISIBILITY_SHAPE } from "connected-components/asset-view/prop-types"
import { useAssetViewTemplateChart } from "../../hooks/use-asset-view-template-chart"
import { ASSET_VIEW_EXPOSURE_CHART } from "../template-chart-config"

export default function ExposureHeader({ modelMetadata, flattenedMetrics, onMetricsChange, compositionVisibility }) {
  const { selectedCategory, setSelectedCategory, selectedMetricDisplay, setSelectedMetricDisplay } = useAssetViewTemplateChart(ASSET_VIEW_EXPOSURE_CHART)

  const analytics = useAnalytics()
  const { handleMetricDisplayChange, handleCategoryChange } = useAssetViewHeaderHandlers({
    track: analytics.track,
    setSelectedMetricDisplay,
    setSelectedCategory,
  })

  const metricOptions = useMemo(
    () => ({ prefix: "exposure", selectedCategory, selectedMetricDisplay }),
    [selectedCategory, selectedMetricDisplay],
  )

  useSourceTemplateMetricIds({ flattenedMetrics, onMetricsChange, metricOptions, compositionVisibility })

  const displayOptions = useMemo(() => {
    return METRIC_OPTIONS.exposure.map(({ label, secondaryText, ...props }) => ({
      primaryText: label,
      secondaryText: typeof secondaryText === "function" ? secondaryText({ isContentSet: false }) : secondaryText,
      ...props,
    }))
  }, [])

  const options = useMemo(
    () => modelMetadata.categories.map(({ id, label }) => ({ id, primaryText: label })),
    [modelMetadata],
  )

  return <>
    <ListItemDropDown
      label="Factor view"
      value={selectedCategory}
      setValue={handleCategoryChange}
      options={options}
      alignMenu="left"
      disablePortal
    />
    <ListItemDropDown
      label="Display"
      value={selectedMetricDisplay}
      setValue={handleMetricDisplayChange}
      options={displayOptions}
      alignMenu="left"
      disablePortal
    />
  </>
}

ExposureHeader.propTypes = {
  modelMetadata: PropTypes.object.isRequired,
  flattenedMetrics: PropTypes.object,
  onMetricsChange: PropTypes.func,
  compositionVisibility: COMPOSITION_VISIBILITY_SHAPE,
}
